import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './react-datepicker-override.css';
import dayjs from 'dayjs';
import axios from 'axios';
import moment from 'moment';
import { FeatureContext } from '../App';

function NewCheckinRegister(props) {
  const navigate = useNavigate();
  const data = props.data.results[0];
  const roomNo = props.roomNo;
  const roomDetailsId = props.roomDetailsId;
  const advBookingId = props.advBookingId;

  const features = useContext(FeatureContext);
  console.log(features);

  const [showDropdown, setShowDropdown] = useState(false);
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyName] = useState(null);
  const [dateValue, setDateValue] = useState(dayjs().toDate());
  const [checkInNo, setCheckInNo] = useState(null);
  const [gstNumber, setGstNumber] = useState(null);
  const [notes, setNotes] = useState(null);
  const [referenceTariff, setReferenceTariff] = useState(null);
  const [bookingID, setBookingID] = useState(null);
  const [foodType, setFoodType] = useState('None');
  const [roomDetails, setRoomsDetails] = useState({});
  const [occupancyType, setOccupancyType] = useState('Double');

  const getRoomDetails = async () => {
    const response = await axios.get('/api/getAllRooms');
    const rooms = response.data;
    for (let i = 0; i < rooms.length; i++) {
      if (rooms[i].room_details_id === roomDetailsId) {
        setRoomsDetails(rooms[i]);
        break;
      }
    }
  };

  useEffect(() => {
    getRoomDetails();
  }, []);

  const handleFoodTypeChange = (event) => {
    setFoodType(event.target.value);
    if (event.target.value === 'Package') {
      // alert('Package');
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  };
  const handleReferenceChange = (event) => {
    if (event.target.value === 'direct') {
      setShowAdditionalFields(false);
    } else {
      setShowAdditionalFields(true);
    }
  };

  async function handleFormSubmit(event) {
    event.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData(event.target);

      const packageAmount =
        formData.get('packageAmount') === null
          ? 0
          : formData.get('packageAmount');
      const reference = formData.get('reference');

      const formDataObject = {
        firstName: data.first_name,
        lastName: data.last_name,
        address: data.address,
        phoneNo: data.contact,
        cityState: data.city_state,
        selectedRooms: [roomDetails],
        foodBillType: foodType,
        referenceTariff: referenceTariff,
        refGstInclusive: false,
        packageFoodAllowance: packageAmount,
        occupancyType: 'Double',
        reference: reference,
        checkInDateTime: dateValue,
        checkInNumber: checkInNo,
        gstNumber: gstNumber,
        notes: notes,
        refBookingID: bookingID,
        checkInTime: moment(dateValue).format('HH:mm:ss'),
        checkInDate: moment(dateValue).format('YYYY-MM-DD'),
        referenceGstInclusive: null,
        companyName: companyName,
      };

      const response = await axios.post(
        '/api/performCheckIn',
        formDataObject
      );

      const updateResponse = await axios.post(
        '/api/updateAdvanceBooking',
        {
          adv_booking_id: advBookingId,
          check_in: checkInNo,
        }
      );

      if (response.status !== 200) {
        throw new Error('Failed to perform check-in');
      }
      setLoading(false);
      const res = response.data.result.msg;
      if (res === undefined) {
        alert('Check-in updated successfully!');
      } else {
        alert(`Check-in update: ${response.data.result.msg}`);
      }

      // if check-in is successful then update checkin no in advance booking table

      navigate('/advanceBookings');
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
    }
  }

  return (
    <div>
      <div
        style={{ display: 'flex', flexDirection: 'column', margin: '0 60px' }}
      >
        <div
          style={{
            marginBottom: '10px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <label
            htmlFor="firstName"
            style={{
              marginRight: '10px',
              padding: '5px',
              border: '1px solid #ccc',
              fontWeight: 'bold',
            }}
          >
            <strong>First Name:</strong>
          </label>
          <span id="firstName">{data.first_name}</span>
          <div style={{ flexGrow: 1 }}></div>
          <label
            htmlFor="address"
            style={{
              marginRight: '10px',
              padding: '5px',
              border: '1px solid #ccc',
              fontWeight: 'bold',
            }}
          >
            <strong>Address:</strong>
          </label>
          <span id="address">{data.address}</span>
        </div>
        <div
          style={{
            marginBottom: '10px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <label
            htmlFor="lastName"
            style={{
              marginRight: '10px',
              padding: '5px',
              border: '1px solid #ccc',
              fontWeight: 'bold',
            }}
          >
            <strong>Last Name:</strong>
          </label>
          <span id="lastName">{data.last_name}</span>
          <div style={{ flexGrow: 1 }}></div>
          <label
            htmlFor="city"
            style={{
              marginRight: '10px',
              padding: '5px',
              border: '1px solid #ccc',
              fontWeight: 'bold',
            }}
          >
            <strong>City:</strong>
          </label>
          <span id="city">{data.city_state}</span>
        </div>
        <div
          style={{
            marginBottom: '10px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <label
            htmlFor="phone"
            style={{
              marginRight: '10px',
              padding: '5px',
              border: '1px solid #ccc',
              fontWeight: 'bold',
            }}
          >
            <strong>Phone no:</strong>
          </label>
          <span id="phone">{data.contact}</span>
          <div style={{ flexGrow: 1 }}></div>
        </div>
      </div>
      <hr></hr>

      <form onSubmit={handleFormSubmit}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            margin: '0 60px',
          }}
        >
          <div
            style={{
              marginBottom: '10px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <label
              htmlFor="checkInDate"
              style={{
                marginRight: '10px',
                minWidth: '100px',
                textAlign: 'right',
              }}
            >
              <strong>Check-In Date:</strong>
            </label>
            <DatePicker
              selected={dateValue}
              showTimeSelect
              dateFormat="dd-MMM-yy,  hh:mm aa"
              onChange={(date) => setDateValue(date)}
              // minDate={dayjs()
              //   .startOf('day')
              //   .toDate()}
              style={{ padding: '5px', width: '100%' }}
            />
            <div style={{ flexGrow: 1 }}></div>
            <label
              htmlFor="checkInNo"
              style={{
                marginRight: '10px',
                minWidth: '100px',
                textAlign: 'right',
              }}
            >
              <strong>Check-In No:</strong>
            </label>
            <input
              type="text"
              id="checkInNo"
              name="checkInNo"
              onChange={(e) => {
                setCheckInNo(e.target.value);
              }}
              required
            />
          </div>
          <div
            style={{
              marginBottom: '10px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <label
              htmlFor="gstNumber"
              style={{
                marginRight: '10px',
                minWidth: '100px',
                textAlign: 'right',
              }}
            >
              <strong>GST Number:</strong>
            </label>
            <input
              type="text"
              id="gstNumber"
              name="gstNumber"
              onChange={(e) => {
                setGstNumber(e.target.value);
              }}
            />
            <div style={{ flexGrow: 1 }}></div>
            <label
              htmlFor="notes"
              style={{
                marginRight: '10px',
                minWidth: '100px',
                textAlign: 'right',
              }}
            >
              <strong>Notes:</strong>
            </label>
            <input
              type="text"
              id="notes"
              name="notes"
              onChange={(e) => {
                setNotes(e.target.value);
              }}
            />
          </div>
        </div>
        <div>
          <hr></hr>
          <div style={{ marginBottom: '10px' }}>
            <label htmlFor="allocatedRoom" style={{ marginRight: '10px' }}>
              <strong>Allocated Room:</strong>
            </label>
            <input
              type="text"
              id="allocatedRoom"
              name="allocatedRoom"
              style={{ width: '200px' }}
              value={roomNo}
              disabled
            />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <label htmlFor="companyName" style={{ marginRight: '10px' }}>
              <strong>Company Name:</strong>
            </label>
            <input
              type="text"
              id="companyName"
              name="companyName"
              onChange={(e) => {
                setCompanyName(e.target.value);
              }}
              style={{ width: '200px' }}
            />

            {features.packageFeatureEnabled && (
              <div style={{ marginTop: '20px' }}>
                <input
                  type="radio"
                  id="package"
                  name="foodType"
                  value="Package"
                  style={{ marginRight: '5px' }}
                  onChange={handleFoodTypeChange}
                  checked={foodType === 'Package'}
                />
                <label htmlFor="package">Package</label>
                <input
                  type="radio"
                  id="cashFood"
                  name="foodType"
                  value="Cash"
                  style={{ marginRight: '5px', marginLeft: '10px' }}
                  onChange={handleFoodTypeChange}
                  checked={foodType === 'Cash'}
                />
                <label htmlFor="cashFood">Cash Food</label>
                <input
                  type="radio"
                  id="none"
                  name="foodType"
                  value="None"
                  style={{ marginRight: '5px', marginLeft: '10px' }}
                  onChange={handleFoodTypeChange}
                  checked={foodType === 'None'}
                />
                <label htmlFor="none">None</label>
              </div>
            )}

            {showDropdown && (
              <div style={{ marginTop: '10px', display: 'inline-block' }}>
                <label htmlFor="packageAmount">
                  <strong>Package Amount: </strong>
                </label>
                <select
                  id="packageAmount"
                  name="packageAmount"
                  style={{ width: '200px' }}
                >
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                </select>
              </div>
            )}
            <div style={{ margin: '10px 0' }}>
              <label htmlFor="reference" style={{ marginRight: '20px' }}>
                <strong>Reference Type: </strong>
              </label>
              <select
                id="reference"
                name="reference"
                style={{ width: '200px' }}
                onChange={handleReferenceChange}
              >
                <option value="direct">Direct</option>
                <option value="mmt">Make My Trip</option>
                <option value="goibibo">Goibibo</option>
                <option value="yatra">Yatra.com</option>
                <option value="travelguru">Travelguru</option>
                <option value="booking.com">Booking.com</option>
                <option value="cleartrip">Clear Trip</option>
                <option value="other">Other</option>
              </select>
            </div>
            {showAdditionalFields && (
              <div>
                <div style={{ marginTop: '10px' }}>
                  <label htmlFor="referenceTariff">
                    <strong>Reference Tariff: </strong>
                  </label>
                  <input
                    type="text"
                    name="referenceTariff"
                    id="referenceTariff"
                    pattern="^[1-9][0-9]*$"
                    inputMode="numeric"
                    title="Please enter valid amount Ex: 1000"
                    style={{ width: '200px' }}
                    onChange={(e) => {
                      setReferenceTariff(e.target.value);
                    }}
                  />
                </div>
                <div style={{ margin: '10px 0' }}>
                  <label htmlFor="bookingID" style={{ margin: '0 20px' }}>
                    <strong>Booking ID: </strong>
                  </label>
                  <input
                    type="text"
                    name="bookingID"
                    id="bookingID"
                    style={{ width: '200px' }}
                    onChange={(e) => {
                      setBookingID(e.target.value);
                    }}
                  />
                </div>
              </div>
            )}
            {features.singleOccupancyFeatureEnabled && (
              <div>
                <label htmlFor="dropdown" style={{ marginRight: '15px' }}>
                  <strong>Occupancy Type:</strong>
                </label>
                <select
                  id="dropdown"
                  value={occupancyType}
                  onChange={(event) => {
                    setOccupancyType(event.target.value);
                  }}
                  style={{ width: '200px' }}
                >
                  <option value="Single">Single</option>
                  <option value="Double">Double</option>
                </select>
              </div>
            )}
          </div>
        </div>
        <button
          type="submit"
          style={{
            padding: '8px 12px',
            backgroundColor: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            width: '20%',
            margin: '20px 0',
          }}
        >
          {loading ? 'Updating...' : 'Update'}
        </button>
      </form>
    </div>
  );
}

export default NewCheckinRegister;
